/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo200,
  GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo401,
  GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo404,
  GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfoPathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfoQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfoPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    cultureInfo: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfoQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfo200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidSyllabusCultureinfoQueryResponse>;
